var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.93,
    height: 22.631,
    viewBox: "0 0 17.93 22.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending_Bookings-act",
    "data-name": "Pending Bookings-act",
    transform: "translate(-236.449 -194.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M285.931,196.2v1.711q.323-.019.649-.019c.218,0,.434.007.649.019V196.2h1.725v-1.56H284.2v1.56h1.725Z",
    transform: "translate(-41.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M237.529,238.413h-1.08a9.006,9.006,0,0,0,8.252,8.252v-1.08a.712.712,0,1,1,1.423,0v1.08a9,9,0,0,0,8.251-8.252H253.3a.712.712,0,0,1,0-1.423h1.079a9,9,0,0,0-8.251-8.252v1.079a.712.712,0,1,1-1.423,0v-1.079a9,9,0,0,0-8.251,8.252h1.08a.712.712,0,0,1,0,1.423Zm7.171-5.52a.712.712,0,0,1,1.423,0v4.1h2.894a.712.712,0,0,1,0,1.423h-3.6a.711.711,0,0,1-.711-.711V232.9Z",
    transform: "translate(0 -29.394)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingActive);
export default __webpack_public_path__ + "static/media/booking_active.257ef296a1c74926158f509a391c50af.svg";
export { ForwardRef as ReactComponent };